import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { addReducer, trackPage } from '@atresmedia/datalayer';
import tagsReducer from './tagsReducer';
import pageReducer from './pageReducer';
import adBlockReducer from './adBlockReducer';

class Analytics extends React.Component {
  static propTypes = {
    history: PropTypes.shape({ listen: PropTypes.func }).isRequired
  };

  componentDidMount() {
    this.setInitialVars();
    this.track();
    if (this.props.history) {
      this.unlisten = this.props.history.listen(() => {
        this.track();
      });
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  setInitialVars = () => {
    const noticiaVideo = document.querySelector(
      'atres-widget[data-type=video-player]'
    )
      ? 'si'
      : 'no';

    addReducer(() => ({ noticiaVideo }));
  };

  track = async () => {
    addReducer(adBlockReducer);

    addReducer(pageReducer);
    addReducer(tagsReducer);

    trackPage();
  };

  render() {
    return '';
  }
}

export default withRouter(Analytics);
